import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SearchContentComponent } from './presentation/search-content/search-content.component';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { InputTextModule } from 'primeng/inputtext';
import { InputSwitchModule } from 'primeng/inputswitch';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DialogModule } from 'primeng/dialog';
import { PasswordModule } from 'primeng/password';
import { MessagesModule } from 'primeng/messages';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { FastAPIRepository } from './repository/fast-api.repository';
import { HttpClientModule } from '@angular/common/http';
import { FastAPIService } from './service/fast-api.service';
import { WebScrapingComponent } from './components/web-scraping/web-scraping.component';
import { TableModule } from 'primeng/table';
import { CheckboxModule } from 'primeng/checkbox';
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { PaginatorModule } from 'primeng/paginator';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { MapPageComponent } from './components/map-page/map-page.component';
import { TooltipModule } from 'primeng/tooltip';
import { CommonModule } from '@angular/common';
import { ShareModule } from './components/share/share.module';
import { TreeTableModule } from 'primeng/treetable';
import { AnalysisPageComponent } from './analysis-page/analysis-page.component';
import { AnalysisDisplayComponent } from './analysis-display/analysis-display.component';
import { NewsModule } from './components/news/news.module';
import { SocialMediaPageComponent } from './components/social-media-page/social-media-page.component';
import { FileUploadModule } from 'primeng/fileupload';
import { HomeModule } from "./components/home/home.module";
import { MultiSelectModule } from 'primeng/multiselect';
import { TagModule } from 'primeng/tag';
import { TestComponent } from './components/test/test.component';
import { EstateComponent } from './components/estate/estate.component';
import { SliderModule } from 'primeng/slider';
import { NlpModule } from './components/nlp/nlp.module';
import { ImportDictionaryComponent } from './components/import-dictionary/import-dictionary.component';
import { GeocodeComponent } from './components/geocode/geocode.component';
import { DividerModule } from 'primeng/divider';
import { PanelModule } from 'primeng/panel';



@NgModule({
    declarations: [
        AppComponent,
        SearchContentComponent,
        WebScrapingComponent,
        MapPageComponent,
        AnalysisPageComponent,
        AnalysisDisplayComponent,
        SocialMediaPageComponent,
        TestComponent,
        EstateComponent,
        ImportDictionaryComponent,
        GeocodeComponent,
    ],
    providers: [FastAPIRepository, MessageService, FastAPIService, ConfirmationService],
    bootstrap: [AppComponent],
    imports: [
        ShareModule,
        CommonModule,
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        InputTextareaModule,
        InputTextModule,
        InputSwitchModule,
        FormsModule,
        ReactiveFormsModule,
        ButtonModule,
        DialogModule,
        FormsModule,
        InputTextModule,
        PasswordModule,
        MessagesModule,
        ToastModule,
        HttpClientModule,
        ProgressSpinnerModule,
        TableModule,
        CheckboxModule,
        CalendarModule,
        DropdownModule,
        PaginatorModule,
        ConfirmDialogModule,
        TooltipModule,
        TreeTableModule,
        NewsModule,
        FileUploadModule,
        HomeModule,
        MultiSelectModule,
        TableModule,
        SliderModule,
        NlpModule,
        DividerModule,
        PanelModule,
        ReactiveFormsModule
    ]
})
export class AppModule { }